/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID } from '@gh/common-shared-data';
import { createEnum, entity, enumeration, EnumSet } from '@gh/core-data';

// tslint:disable:variable-name

export const SentToOfficeEntryPoint = createEnum('SENT_TO_OFFICE_ENTRY_POINT', {
  HP: 'HOUSE_PLANS',
  SP: 'SPEC_TEMPLATES',
  CSMasters: 'CS_MASTERS',
  SCH: 'SCH_TEMPLATES',
});

export type SentToOfficeEntryPoint = EnumSet<typeof SentToOfficeEntryPoint>;

export type SendToOfficeItemDto = {
  sourceOfficeId: ID;
  destinationOfficeId: ID;
  itemIds: ID[];
  entryPoint: SentToOfficeEntryPoint;
  isCreateNew: boolean;
};

export const SendToOfficeItemMapper = entity<SendToOfficeItemDto>({
  entryPoint: enumeration(SentToOfficeEntryPoint),
});
